import { createVNode as a, mergeProps as n } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HttpErrorTwotoneStandard.js";
import d from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return a(d, n(e, {
    icon: p
  }), null);
};
r.displayName = "HttpErrorTwotoneStandard";
r.inheritAttrs = !1;
export {
  r as default
};
